export const NEED_STAGE_LABELS = {
    NEW: 'New',
    REQUESTED: 'Requested',
    SOURCING: 'Sourcing',
    BOOKED: 'Booked',
    PAID: 'Paid in full',
};
//# sourceMappingURL=need.js.map